import React from 'react';

function CardsSkeleton({ length = 1 }: { length?: number }) {
  return (
    <div className="space-y-3 mt-2">
      {Array.from({ length }).map((_, index) => (
        <div
          key={index}
          className="rounded-md border border-slate-300 bg-slate-100 mx-1 p-4 animate-pulse"
        >
          <div className="space-y-4">
            {/* Title */}
            <div className="h-4 w-[7.5rem] rounded bg-slate-300" />

            {/* Line 1 */}
            <div className="h-4 w-full rounded bg-slate-300" />

            {/* Line 2 */}
            <div className="h-4 w-[95%] rounded bg-slate-300" />
          </div>
        </div>
      ))}
    </div>
  );
}

export const CardSkeleton = React.memo(CardsSkeleton);
